import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import type { RootState } from "../redux/store";
import { checkUserLoggedIn } from "../_helpers/checkUserLoggedIn";

const PublicRoute: React.FC = () => {
  const user = useSelector((state: RootState) => state.user.user);
  const loggedIn = checkUserLoggedIn();
  console.log('user', user)
  console.log('loggedIn', loggedIn)
  // If already logged in → dashboard
  if (loggedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  // Otherwise allow public routes
  return <Outlet />;
};

export default PublicRoute;